import Image from "next/image"
import styles from "./ContactBanner.module.css"
import { Container, Row, Col } from "react-bootstrap"
import Link from "next/link"
import { Button } from "antd"

const ContactBanner: React.FC = () => (
  <Container>
    <Row>
      <Col xs={{ span: 12 }} md={{ span: 6 }}>
        <Image
          src={
            "https://res.cloudinary.com/dzzkeb6xp/image/upload/v1688991427/Foto_Contenedor_1_qf1q2f.png"
          }
          alt={"Imagen de contacto"}
          width={576}
          height={567}
        />
      </Col>
      <Col xs={{ span: 12 }} md={{ span: 6 }} className={styles.textParagraph}>
        <br />
        <h2 className={styles.textTitle}>
          ¿Necesitas ayuda?
          <br />
          Pregúntanos
        </h2>
        <br />
        <div className={styles.contactLink}>
          <Link href="/contacto">
            <Button
              type="primary"
              size={"large"}
              style={{
                backgroundColor: "var(--Aguamarina-Fiva, #00f5ea)",
                color: "var(--fiva-color, #401c72)",
                fontWeight: "bold",
                padding: "1.4rem 1.7rem",
                borderRadius: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.25rem",
              }}
            >
              Contáctanos
            </Button>
          </Link>
        </div>
      </Col>
    </Row>
  </Container>
)
export default ContactBanner
